
export const HTTP_MESSAGES = {
	"ECONNREFUSED": "Error de conexión. Verifique su conexión a Internet.",
	"ERR_NETWORK": "Error de conexión. Verifique su conexión a Internet.",
	"GATEWAY_TIMEOUT": "El servidor tardó demasiado en responder. Es posible que la operación se haya completado: compruebe el resultado antes de volver a intentarlo.",
}



const messages = {
	"ECONNREFUSED": {
		message: 'Error de red.',
		description: 'No se pudo establecer conexión con el servidor. Verifique su conexión a Internet.',
	},
	"ERR_NETWORK": {
		message: 'Error de red.',
		description: 'No se pudo establecer conexión con el servidor. Verifique su conexión a Internet.',
	}
}

const codes = {
	"ECONNREFUSED": 504,
}

export const getErrorDescription = (code:any) => {
	return messages[code] ?? messages['ECONNREFUSED']
}
export const getErrorCodeNumber = (code:any) => {
	return codes[code] ?? codes['ECONNREFUSED']
}
